import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './GroupForm.css';

class GroupForm extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.any,
        title: PropTypes.string,
      }),
    ).isRequired,
    handleSelect: PropTypes.func.isRequired,
    selected: PropTypes.shape(),
  };

  static defaultProps = {
    selected: null,
    isDealerPage: false,
  };

  render() {
    const { items, selected } = this.props;

    return (
      <div className={s.root}>
        {items.map(item =>
          <div
            key={item.id}
            className={cx(s.item, {
              [s.active]: selected && item.id === selected.id,
            })}
            onClick={e => this.props.handleSelect(item)}
          >
            <span>
              {item.title}
            </span>
          </div>,
        )}
      </div>
    );
  }
}

export default withStyles(s)(GroupForm);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/GroupForm/GroupForm.js